
define('text!modules/T1App/edit/access/templates/tabs.html',[],function () { return '<div class="w-box apps-access-tabs"></div>\n';});

